import * as yup from "yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaCircleNotch } from "react-icons/fa";
import { IoSaveOutline } from "react-icons/io5";

import { paymentConfirmationServices as confirmation } from "./../../../services/paymentConfirmationServices";

import ReactSelect from "./../../../components/common/ReactSelect";
import Toaster from "../../../components/common/Toaster";

const schema = yup.object({
  status: yup.object().shape({
    label: yup.string().required("Please select status."),
    value: yup.string().required("Please select status."),
  }),
});

const ConfirmationStatusForm = ({
  data,
  onSuccess,
  isLoading,
  setLoading,
  setShow,
}) => {
  const statuses = confirmation.getPaymentConfirmationStatuses();

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (info) => {
    try {
      setLoading(true);

      const item = { ...info };
      item["status"] = info.status.value;
      item["status_type"] = info.status.label;

      await confirmation.saveConfirmationStatusAsync(item);

      Toaster.Success("Payment Created Successfully");

      onSuccess(item);
      setShow(false);
      setLoading(false);
    } catch (ex) {
      setLoading(false);
      Toaster.Error("Something went wrong.");
    }
  };

  useEffect(() => {
    if (data) {
      setValue("payment_confirmation_id", data.id);
      setValue("id", data.id);
    }
  }, [data, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="statuses-dropdown"
            name="status"
            title="Payment Confirmation Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default ConfirmationStatusForm;
